/* REM Optics — Theme JS v2 */
document.addEventListener('DOMContentLoaded', function () {
  initFAQ();
  initLensTabs();
  initVariantBtns();
});

function initFAQ() {
  document.querySelectorAll('.faq-item__question').forEach(function (q) {
    q.addEventListener('click', function () {
      this.closest('.faq-item').classList.toggle('open');
    });
  });
}

function initLensTabs() {
  const tabs = document.querySelectorAll('.lens-tab');
  if (!tabs.length) return;
  tabs.forEach(function (tab, i) {
    tab.addEventListener('click', function () { switchLens(i); });
  });
}

function switchLens(i) {
  document.querySelectorAll('.lens-tab').forEach(function (t, j) {
    t.classList.toggle('active', i === j);
  });
  document.querySelectorAll('.lens-panel').forEach(function (p, j) {
    if (i === j) {
      p.classList.add('active');
      p.style.display = 'grid';
      p.classList.add('fade-up');
      setTimeout(function () { p.classList.remove('fade-up'); }, 400);
    } else {
      p.classList.remove('active');
      p.style.display = 'none';
    }
  });
}

function scrollToShop(lensIndex) {
  var shopSection = document.getElementById('shop-section');
  if (shopSection) {
    shopSection.scrollIntoView({ behavior: 'smooth' });
    setTimeout(function () { switchLens(lensIndex); }, 500);
  }
}

function initVariantBtns() {
  document.querySelectorAll('.variant-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.variant-btn').forEach(function (b) { b.classList.remove('selected'); });
      btn.classList.add('selected');
    });
  });
}
